import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Component, OnDestroy, OnInit } from '@angular/core';

import { CANDIDATE_FORM_UI, ERROR_MESSAGE, VERIFY_UI } from './../../constants/ui-strings';
import { StateManagementService } from 'src/app/services/state-management.service';
import { TestService } from 'src/app/services/test.service';
import { BrowserIdService } from 'src/app/services/browser-id.service';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ValidateTestResponseBody } from 'src/app/model/validate-test';
import { TOAST_CONFIGURATION } from 'src/app/constants/constants';


@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrl: './verify.component.scss',
})
export class VerifyComponent implements OnInit, OnDestroy {
  candidateFormUIString = VERIFY_UI;
  isLoading: boolean = false;
  browserId: string;
  browserIdReady: boolean = false;
  verifyTestSubscription$: Subscription;
  candidateDetailsForm: FormGroup = new FormGroup({
    code: new FormControl('',[Validators.required])
  })

  constructor (
    private stateManagementService: StateManagementService,
    private router: Router,
    private route: ActivatedRoute,
    private testService: TestService,
    private messageService: MessageService,
    private browserIdService: BrowserIdService,
  ) {}

  ngOnInit(): void {
    this.browserIdService.ready().then((id) => {
      this.browserId = id;
      this.browserIdReady = true;
    });
    this.route.paramMap.subscribe({
      next: (param) => {
        this.candidateDetailsForm.setValue({
          'code': param.get('test_code')
        })
      }
    })
  }

  async verifyCandidate(): Promise<void> {
    const testCode: string = this.candidateDetailsForm.get('code').value;
    this.isLoading = true;
    this.verifyTestSubscription$ = this.testService.verifyTest(testCode).subscribe({
      next: (res) => {
        if(res.success) {
          this.stateManagementService.isCandidateFormAllowed = true;
          this.setVerifyResponse(res.body,testCode);
          if (res.body.TEST_START_TIME != undefined) {
            this.router.navigate(['/']);
          } else {
            this.router.navigate(['/detail']);
          }
        } else {
          this.messageService.add({
          severity: TOAST_CONFIGURATION.info,
          detail: res.message,
          closable: true
        })
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.messageService.add({
          severity: TOAST_CONFIGURATION.warning,
          summary: ERROR_MESSAGE.unauthorized_summary,
          detail: ERROR_MESSAGE.unauthorized_msg,
        })
        this.isLoading = false;
      }
    })
  }

  setVerifyResponse(body: ValidateTestResponseBody,testCode: string): void {
    this.testService.testData.set({
      test_id: body.NODE,
      test_key: testCode,
      start_date: body.START_DATE,
      end_date: body.END_DATE,
      duration: body.DURATION,
      name: body.NAME,
      phone: body.PHONE,
      email: body.EMAIL,
      proctor_settings: {
        enforce_camera: body.PROCTOR_SETTINGS.ENFORCE_CAMERA,
        max_tab_allowed: body.PROCTOR_SETTINGS.MAX_ALLOWED_TAB_SWITCH,
        enforce_fullscreen: body.PROCTOR_SETTINGS.ENFORCE_FULLSCREEN
      },
      last_sync_time: body.LAST_SYNC_TIME,
      start_time: body.TEST_START_TIME,
      browser_id: this.browserId,
      test_name: body.TEST_NAME
    })
  }

  clearInputs(): void {
    this.candidateDetailsForm.reset();
  }

  ngOnDestroy(): void {
    this.verifyTestSubscription$?.unsubscribe();
  }
}
